export const ENTITY_NAME = {
  STORE: 'Store',
  DEPARTMENT: 'Department',
  GROUP: 'Group',
  VIEW_GROUP: 'ViewGroup'
};
